import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lakhSeparator'
})
export class LakhSeparatorPipe implements PipeTransform {

  transform(value: number | string): string {
    if (value == null) {
      return '';
    }

    let num = value.toString().trim();

    if (["0.00", "0.0", "0", "0.000", "0.0000"].includes(num)) {
      return num;
    }

    let [integerPart, decimalPart] = num.split('.');

    let lastThree = integerPart.substring(integerPart.length - 3);
    let otherNumbers = integerPart.substring(0, integerPart.length - 3);

    if (otherNumbers) {
      lastThree = ',' + lastThree;
    }

    let formattedInteger = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;

    return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
  }
}
